<template>
  <div></div>
</template>

<!-- <template >
  <div>
    <div
      class="row m-0 fixed-bottom time"
      style="
        height: 50px;
        max-width: 590px;
        margin: 0 auto !important;
        z-index: 2;
      "
    >
      <div class="col-3 text-center errorsTimeMap">
        {{ errorNumber }}
        <span id="erreurs">טעויות</span>
      </div>
      <div class="col-6 text-center errorsTimeMap">
        {{ secondsToTime }}
        <span id="runningTime">זמן רץ</span>
      </div>
      <div
        class="col-3 text-center errorsTimeMap"
        @click="slideMapInn"
        style="color: rgba(27, 121, 17, 0.8)"
      >
        <span id="carte">מפה</span>
        <svg
          class="bi bi-map"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M15.817.613A.5.5 0 0116 1v13a.5.5 0 01-.402.49l-5 1a.502.502 0 01-.196 0L5.5 14.51l-4.902.98A.5.5 0 010 15V2a.5.5 0 01.402-.49l5-1a.5.5 0 01.196 0l4.902.98 4.902-.98a.5.5 0 01.415.103zM10 2.41l-4-.8v11.98l4 .8V2.41zm1 11.98l4-.8V1.61l-4 .8v11.98zm-6-.8V1.61l-4 .8v11.98l4-.8z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>

    <div
      v-if="rowPhotoMissingWord"
      style="
        display: block;
        margin: 0px;
        padding: 0px;
        min-height: calc(100vh - 150px);
        margin-bottom: 55px;
      "
      class="mt-4 container d-flex"
    >
      <div class="row p-0 m-0" style="max-width: 590px">
        <div
          class="
            row
            align-items-center
            justify-content-center
            align-self-center
            m-0
            p-0
          "
          style="min-height: 20%"
        >
          <div class="col-12 p-0 m-0">
            <p class="text-center px-3 h4">על המפה, תמצאו את הנקודה מספר:</p>
          </div>
          <div class="fw-bold h4 text-center pointNumber my-3">
            {{
              Object.values(points)[pointsArrayOrder[pointNum] - 1].pointNumber
            }}
          </div>
          <div class="col-12 p-0 m-0">
            <p class="px-2 text-center">
              במקום, תחפשו את השלט המופיע למטה. תמלאו את המילה החסרה.
            </p>
          </div>
        </div>
        <div
          class="
            row
            align-items-center
            justify-content-center
            align-self-center
            m-0
            p-0
          "
          style="min-height: 40%"
        >
          <img id="imgUrl" class="align-center" width="95%" :src="getImgUrl" />
        </div>
        <div
          class="
            row
            align-items-center
            justify-content-center
            align-self-center
            m-0
            p-0
          "
          style="min-height: 15%; width: 100%; margin-bottom: 50px !important"
        >
          <div class="mt-3 col-10 pl-1">
            <input
              class="center fullWidth text-center"
              aria-describedby="missingWordAnswer"
              placeholder="מילה חסרה בתמונה"
              name="missingWordAnswer"
              label="missingWordAnswer"
              id="missingWordAnswer"
              v-model="missingWordAnswer"
              required
              style="
                border-radius: 36px;
                height: 50px;
                border: 1px rgba(27, 121, 17, 0.8) solid;
                width: 100%;
              "
            />
         </div> 
          </div>
          <div
            class="col-2 pl-0"
            style="
              font-size: 40px;
              color: rgba(27, 121, 17, 0.8);
              padding: 0px;
              margin-top: 7px;
            "
          >
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-arrow-left-circle-fill"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              @click="checkMissingWord"
            >
              <path
                fill-rule="evenodd"
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.646 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l2.147 2.146z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div
      id="questionDiv"
      v-if="rowPhotoMissingWord === false"
      style="display: block"
      align="center"
    >
      <div class="my-5 px-1">
        <p class="question px-3" right>
          {{ questionSuffled[questionNumber].question }}
        </p>
      </div>

      <div :key="answer.id" v-for="answer in getAnswerArray">
        <button
          class="fullWidth colorBtn btn fw-bold mb-3"
          style="background-color: #4f9e2c"
          @click="checkAnswer(answer)"
        >
          {{ answer }}
        </button>
      </div>
    </div>

    <div
      v-if="showPointInformation === true && rowPhotoMissingWord === false"
      class="over"
    >
      <div class="myModal p-4 mb-5 modalInformationPoint">
        <div class="container">
          <div class="row">
            <div class="col-12 align-self-start">
              <div class="mb-4" right>
                <strong>האם ידעתם?</strong>
              </div>
            </div>

            <div class="col-12 align-self-center">
              <div>
                {{
                  Object.values(this.points)[
                    this.pointsArrayOrder[this.pointNum] - 1
                  ].pointInformation
                }}
              </div>
            </div>
            <div class="col-12 align-self-end">
              <button
                class="fullWidth colorBtn btn fw-bold mt-3"
                style="background-color: rgb(119, 190, 87); margin-bottom: 50px"
                @click="fadeInDiv"
              >
                המשך
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogCorrectAnswer" class="over">
      <div
        class="myModal p-4 mb-5 green container d-flex"
        @click="hideImageQuestion"
      >
        <div class="row justify-content-center align-self-center">
          <audio id="audio" controls autoplay style="display: none">
            <source src="../../static/sounds/applause.mp3" type="audio/mp3" />
          </audio>
          <div class="h2 mb-4 text-center col-12" style="font-family: noot">
            יפה לך!!!
          </div>
          <div class="mb-4 text-center col-12">תשובה נכונה</div>
          <div class="col-12">
            <div
              class="fullWidth fw-bold h3 text-center"
              style="background-color: rgb(119, 190, 87); width: 100%"
            >
              בוא נמשיך
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogWrongAnswer" class="over">
      <div
        class="myModal p-4 mb-5 red container d-flex"
        @click="(dialogWrongAnswer = false), (missingWordAnswer = '')"
      >
        <div
          class="row justify-content-center align-self-center"
          style="color: white; background: #d41a1b"
        >
          <div class="col-12 h2 mb-4 text-center" style="font-family: noot">
            הופס...
          </div>
          <div class="col-12 mb-4 text-center">התשובה לא נכונה</div>
          <audio id="audio" controls autoplay style="display: none">
            <source
              src="../../static/sounds/buzzerWrong.mp3"
              type="audio/mp3"
            />
          </audio>

          <div
            class="fullWidth fw-bold h3 text-center"
            style="width: 100%"
          >
            בואו ננסה שוב!
          </div>
        </div>
      </div>
    </div>

    <div v-if="showLastDialog" class="over container d-flex">
      <div
        class="
          myModal
          p-2
          green
          d-flex
          row
          justify-content-center
          align-self-center align-items-center
          mt-0
        "
        @click="showResults"
      >
        <audio id="audio" controls autoplay style="display: none">
          <source src="../../static/sounds/applause.mp3" type="audio/mp3" />
        </audio>
        <div class="h4 p-2 col-12 text-center" style="font-family: noot">
          מעולים אתם!
        </div>
        <div class="p-2 col-12">סיימתם את המשחק ניווט!</div>
        <div class="p-2 col-12">
          אנחנו מקווים שנהנתם מהביקור שלכם במוזאיון אין דור.
        </div>
        <div class="border border-white p-4">
          <div class="p-2 col-12 fw-bold">התוצאות שלכם:</div>
          <div class="p-2 col-12 font-italic">
            מספר טעויות: {{ errorNumber }}
          </div>
          <div class="p-2 col-12 font-italic">
            זמן משחק: {{ gameSecondToTime }}
          </div>
        </div>

        <div class="p-2 col-12">
          מכאן אתם יכולים לבדוק את מיקומכם במרוץ. בהצלחה!
        </div>
      </div>
    </div>

    <div id="map">
      <span
        @click="removeMap"
        style="
          position: absolute;
          top: -5px;
          font-size: 53px;
          z-index: 100;
          color: white;
          left: 15px;
        "
      >
        <svg
          class="bi bi-x-circle"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
          />
          <path
            fill-rule="evenodd"
            d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
          />
          <path
            fill-rule="evenodd"
            d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
          />
        </svg>
      </span>
      <GmapMap
        :center="{
          lat: Number(mapParameters.lat),
          lng: Number(mapParameters.lng),
        }"
        :zoom="Number(mapParameters.zoom)"
        map-type-id="satellite"
        style="width: 100%; height: 100vh"
        :options="{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false,
        }"
      >
        <GmapMarker
          style="margin-right: 10px !important"
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          :label="{ text: `${index + 1}`, color: 'white', fontSize: '9px' }"
          @click="center = m.position"
        />
      </GmapMap>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      firstQuestion: 1,
      showPointInformation: false,
      secondsToTime: "00:00:00",
      gameSecondToTime: "",
      totalSeconds: 0,
      startTime: Date.now(),
      endTime: "",
      showMap: false,
      showLastDialog: false,
      key: "",
      questiomMultipleChoices: true,
      rowPhotoMissingWord: true,
      dialogWrongAnswer: false,
      dialogCorrectAnswer: false,
      missingWordAnswer: "",
      loading: false,
      src: "",
      timeNow: "",
      questionNumber: -1,
      errorNumber: 0,
      pointNum: 0,
      letter: "",
      allLetters: "",
      gameTimeInSecond: "",
    };
  },
  mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    this.countSeconds();
    if (localStorage.getItem("questionNumber")) {
      if (localStorage.getItem("pointNumberOuchui")) {
        this.pointNum = localStorage.getItem("pointNumberOuchui");
      } else {
        this.pointNum = 0;
      }
      this.startTime = localStorage.getItem("startTimeOuchui");
      this.errorNumber = localStorage.getItem("errorNumber");
      this.questionNumber = localStorage.getItem("questionNumber");
      this.firstQuestion = localStorage.getItem("firstQuestion");
      this.rowPhotoMissingWord = JSON.parse(
        localStorage.getItem("rowPhotoMissingWord")
      );
    }
    // Show loading animation.
    // setTimeout(function() {
    //   // var playPromise = document.getElementById("audio").play();
    //   var playPromise = document.querySelector("audio");
    //   if (playPromise !== undefined) {
    //     playPromise
    //       .then(_ => {})
    //       .catch(error => {
    //         // Auto-play was prevented
    //         console.log("errrrrrrorrrr playing");
    //         // Show paused UI.
    //       });
    //   }
    // }, 500);
    // }
  },
  computed: {
    mapParameters() {
      return this.$store.getters.mapParameters;
    },
    gameParameters() {
      return this.$store.getters.gameParameters;
    },
    group() {
      return this.$store.getters.group;
    },
    points() {
      return this.$store.getters.points;
    },
    markers() {
      var markers = this.$store.getters.markers;
      var markersArray = [];
      markers.forEach((marker) => {
        markersArray.push({ position: { lat: marker.lat, lng: marker.lng } });
      });
      return markersArray;
    },
    questions() {
      return this.$store.getters.questions;
    },
    getImgUrl() {
      return Object.values(this.points)[
        this.pointsArrayOrder[this.pointNum] - 1
      ].imageUrl;
    },
    pointsArrayOrder() {
      console.log(
        "[computed startgame] pointsArrayOrder",
        this.$store.getters.pointsArrayOrder
      );

      return this.$store.getters.pointsArrayOrder;
    },
    questionSuffled() {
      console.log(
        "[computed startgame] questionSuffled",
        this.$store.getters.questionsShuffled
      );
      return this.$store.getters.questionsShuffled;
    },
    getAnswerArray() {
      let answerArray;
      answerArray = [
        this.questionSuffled[this.questionNumber].wrongAnswer1,
        this.questionSuffled[this.questionNumber].wrongAnswer2,
        this.questionSuffled[this.questionNumber].wrongAnswer3,
        this.questionSuffled[this.questionNumber].correctAnswer,
      ];
      let currentIndex = answerArray.length,
        temporaryValue,
        randomIndex;
      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = answerArray[currentIndex];
        answerArray[currentIndex] = answerArray[randomIndex];
        answerArray[randomIndex] = temporaryValue;
      }
      return answerArray;
    },
  },
  methods: {
    toogleShowImage() {
      console.log(
        "b4 toogleShowImage this.rowPhotoMissingWord",
        this.rowPhotoMissingWord
      );
      this.rowPhotoMissingWord = !this.rowPhotoMissingWord;
      console.log(
        "AFTER toogleShowImage this.rowPhotoMissingWord",
        this.rowPhotoMissingWord
      );
    },
    cleanLocalStorage() {
      localStorage.clear();
      this.$router.push("/");
    },
    slideMapInn() {
      document.getElementById("map").className = "showMap";
    },
    removeMap() {
      document.getElementById("map").classList.remove("showMap");
    },
    fadeInDiv() {
      this.showPointInformation = false;
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").className = "fadeIn";
      } else {
        console.log("[fadeInDiv] no questionDiv");
      }
    },
    countSeconds() {
      setInterval((_) => {
        this.timeNow = Date.now();
        this.totalSeconds = Math.floor((this.timeNow - this.startTime) / 1000);
        var pad = function (num, size) {
            return ("000" + num).slice(size * -1);
          },
          time = parseFloat(this.totalSeconds).toFixed(3),
          hours = Math.floor(time / 60 / 60),
          minutes = Math.floor(time / 60) % 60,
          seconds = Math.floor(time - minutes * 60);
        this.secondsToTime =
          pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
      }, 1000);
    },
    // showResults() {
    //   console.log("showResults");
    //   localStorage.clear();
    //   this.$router.push("/results");
    //   this.$store.dispatch("getResults", this.gameParameters.navigationName);
    // },
    checkMissingWord() {
      if (
        this.missingWordAnswer.toLowerCase() ===
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .missingWord
      ) {
        this.dialogCorrectAnswer = true;
      } else {
        this.dialogWrongAnswer = true;
        this.errorNumber++;
        localStorage.setItem("errorNumber", this.errorNumber);
      }
    },
    checkAnswer(answer) {
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").classList.remove("fadeIn");
      } else {
        console.log("[checkAnswer] No questionDiv");
      }
      if (answer === this.questionSuffled[this.questionNumber].correctAnswer) {
        var allPoints = Object.keys(this.points);
        if (
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber == this.gameParameters.lastPoint
        ) {
          this.showLastDialog = true;
          // GET THE TOTAL TIME OF THE GAME
          this.endTime = Date.now();
          this.gameTimeInSecond = Math.floor(
            (this.endTime - this.startTime) / 1000
          );
          var pad = function (num, size) {
              return ("000" + num).slice(size * -1);
            },
            time = parseFloat(this.gameTimeInSecond).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);
          this.gameSecondToTime =
            pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
          // SEND THE RESULTS TO THE DATABASE
          this.$store.dispatch("checkResults", {
            errorNumber: this.errorNumber,
            gameSecondToTime: this.gameSecondToTime,
            gameTimeInSecond: this.gameTimeInSecond,
          });
        } else {
          this.dialogCorrectAnswer = true;
        }
      } else {
        this.dialogWrongAnswer = true;
        this.errorNumber++;
        localStorage.setItem("errorNumber", this.errorNumber);
      }
    },
    hideImageQuestion() {
      localStorage.setItem("startTimeOuchui", this.startTime);
      // ADD A FADEINN CLASS TO THE QUESTION DIV
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").className = "fadeIn";
      } else {
      }
      // Here I check if I need to show the Information Page as per the game parameters
      this.dialogCorrectAnswer = false;
      if (this.gameParameters.infoPage === true && this.firstQuestion === 1) {
        this.showPointInformation = true;
      }
      // Here I deal with the case that the question is NOT null
      // if (this.questionSuffled[this.questionNumber + 1] != null) {
      this.missingWordAnswer = "";
      // if (this.firstQuestion < 3) {
      // *****************************************************************************************
      if (
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .pointNumber ==
        this.questionSuffled[this.questionNumber + 1].pointLinked
      ) {
        console.log(
          "[hideImageQuestion] Object.values(this.points)[",
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber
        );

        console.log(
          "[hideImageQuestion] this.questionSuffled[this.questionNumber + 1].questionNumber",
          this.questionSuffled[this.questionNumber + 1].pointLinked
        );
        //***************************************************************************** */
        this.questionNumber++;
        localStorage.setItem("questionNumber", this.questionNumber);
        this.firstQuestion++;
        localStorage.setItem("firstQuestion", this.firstQuestion);
        this.rowPhotoMissingWord = false;
        localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
      } else {
        console.log("[hideImageQuestion] ELSEEEEEEEEEEEEEEEEEEE");
        console.log(
          "[hideImageQuestion] Object.values(this.points)[",
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber
        );

        console.log(
          "[hideImageQuestion] this.questionSuffled[this.questionNumber + 1].questionNumber",
          this.questionSuffled[this.questionNumber + 1].questionNumber
        );
        localStorage.setItem("questionNumber", this.questionNumber);
        this.rowPhotoMissingWord = !this.rowPhotoMissingWord;
        localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
        if (this.rowPhotoMissingWord) {
          this.pointNum++;
          localStorage.setItem("pointNumberOuchui", this.pointNum);
          this.firstQuestion = 1;
          localStorage.setItem("firstQuestion", 1);
        }
      }
    },
  },
};
</script>

<style scoped>
#erreurs {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 20px);
}
#runningTime {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 16px);
}
#carte {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 12px);
}
.center {
  display: block;
  margin: 0px auto;
}
#mapButton {
  width: 30px;
  position: absolute;
  top: 4px;
  right: -10px;
  margin-right: calc(50vw - 155px);
  font-size: 25px;
  color: white;
  /* border: solid 1px black; */
  width: 42px;
  height: 40px;
  padding: 5px;
  /* background: white; */
  z-index: 5;
}
#map {
  position: fixed;
  top: -100vh;
  right: 0;
  height: 100vh;
  width: 100%;
  z-index: 100;
  overflow: hidden;
  transition: all 1s;
}
.showMap {
  position: fixed;
  top: 0 !important;
  right: 0;
  height: 100vh;
  width: 100%;
  z-index: 100;
  overflow: hidden !important;
  transition: all 1s;
}
#imgUrl {
  display: block;
  margin: 0 auto;
}
.errorsTimeMap {
  background: rgba(255, 255, 255, 1);
  border: none;
}
.errorsTimeMap > svg {
  position: relative;
  bottom: 3px;
}
.pointNumber {
  margin: 0 auto;
  border: rgba(27, 121, 17, 0.8) solid 2px;
  border-radius: 100px;
  height: 55px;
  width: 55px;
  font-size: 36px;
  padding-right: 1px;
  padding-top: 4px;
}
.verticalAlign {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 80%;
}
.myModal {
  min-height: 200px;
  overflow: auto;
  width: 300px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  color: white;
}
.modalInformationPoint {
  box-shadow: none;
  border: solid rgb(9, 133, 235) 3px;
  margin-top: 1vh;
  width: 98vw;
  font-size: 20px;
  height: 98vh;
  overflow: auto;
  background: #ffffff;
  color: black;
}
.red {
  background-color: #d41a1b;
  border: solid white 2px;
}
.green {
  background-color: rgb(119, 190, 87);
  border: 2px white solid;
}
.over {
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 3;
}
.colorBtn {
  border-radius: 36px;
  height: 56px;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.question {
  text-align: center;
  font-family: "Assistant", sans-serif;
  font-weight: 400;
  font-size: 22px;
  color: black;
}
.btnAnswer {
  margin: 0 auto;
  width: 320px;
  height: 60px;
  border-radius: 35px;
  font-size: 20px;
  color: white;
  background: rgb(64, 150, 83) !important;
}
.title {
  font-size: 25px;
  text-align: right;
  color: black;
}
.userName {
  font-size: 18px;
  text-align: left;
  color: black;
}
.time {
  letter-spacing: 0.05em;
  font-size: 24px;
  font-family: "Cabin", sans-serif;
  text-align: center;
  color: rgb(14, 15, 14, 0.8);
}
.startTime {
  letter-spacing: 0.05em;
  font-size: 40px;
  padding: 5px 0;
  font-family: "Inconsolata", monospace;
  color: #ffffff;
  text-align: center;
  position: relative;
  left: 50%;
  margin-top: 50px;
  top: -24px;
  transform: translate(-50%, -50%);
  color: #daf6ff;
}
.hebrewText {
  text-align: right;
  font-size: 15px;
  padding-right: 5px;
  color: black;
}
.fadeIn {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style> -->